import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import About from "../pages/About";
import ManagerDashboard from "../pages/dashboard/ManagerDashboard";
import TradesmanDashboard from "../pages/dashboard/TradesmanDashboard";
import NotFound from "../pages/NotFound";
import ManagerSettings from "../pages/dashboard/ManagerSettings";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/manager-dashboard" element={<ManagerDashboard />} />
      <Route path="/manager-settings" element={<ManagerSettings />} />
      <Route path="/tradesman-dashboard" element={<TradesmanDashboard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
